/**
 * @fileoverview GET handler for the "/api/calculated_filters/:id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedFiltersIdAppGroupId } from "./constants";
import type {
  GetApiCalculatedFiltersIdAppGroupIdResult,
  GetApiCalculatedFiltersIdAppGroupIdResultErrors,
} from "./types";
import { isGetApiCalculatedFiltersIdAppGroupIdResult } from "./validators";

export const getApiCalculatedFiltersIdAppGroupId = reactQueryFetcherAdapter(
  apiCalculatedFiltersIdAppGroupId,
  createGetFetcherFunctionWithShadowError<GetApiCalculatedFiltersIdAppGroupIdResultErrors>()(
    (signal: AbortSignal, id: string, appGroupId: string): Promise<GetApiCalculatedFiltersIdAppGroupIdResult> => {
      return fetch(`/api/calculated_filters/${id}/${appGroupId}`, "GET", {}, { signal });
    }
  ),
  isGetApiCalculatedFiltersIdAppGroupIdResult
);
